<template>
    <div class="container mx-auto pt-10 md:pt-20 md:pt-32">
        <h1 class="text-3xl font-bold">
            Карта сайта
        </h1>
        <hr class="mb-6 mt-6"/>
        <div class="space-y-4">
            <div v-for="(routeItem, key) in routes" :key="key">
                <div>
                    <Link :href="route(routeItem.route_name)"
                          class="text-lg font-medium text-indigo-600 hover:underline">
                        {{ routeItem.title }}
                    </Link>
                    <div v-if="routeItem.sub_routes">
                        <div class="ml-6 mt-2">
                            <ul class="space-y-2">
                                <li v-for="(subRoute, subKey) in routeItem.sub_routes" :key="subKey">
                                    <Link :href="subRoute.route_name"
                                          class="text-indigo-600 font-medium hover:underline">
                                        {{ subRoute.title }}
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Link} from "@inertiajs/vue3";

export default {
    name: "Sitemap",
    components: {
        Link
    },
    props: {
        routes: Object,
    },
};
</script>

<style scoped>

</style>
